'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.name = undefined;

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

require('./localizationService');

require('./styleService');

require('./localeClass');

require('./dateInput');

require('./customStyles');

require('./lightIf');

require('./lightIfHighPriority');

require('./parsedate');

require('./parsenumber');

require('./scopedTransclude');

require('./scopedTranscludeSlot');

require('./tooltip');

require('./trimdecimals');

require('./languageRefresh');

require('./teleportService');

require('./teleportTarget');

require('./teleportTo');

require('./fileOnChange');

require('./dateValidate');

require('./countrySelect');

require('./genderSelect');

require('./busSelect');

require('./load');

require('./loadingOverlay');

require('./loadingOverlayService');

require('./modalService/modalService');

require('./modalService/modalServiceModal');

var _countryService = require('./countryService');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var name = exports.name = _module3.default.name;

_module3.default.service('countryService', _countryService.CountryService);


//////////////////
// WEBPACK FOOTER
// ./src/core/index.js
// module id = 26
// module chunks = 0 2